import { render, staticRenderFns } from "./RateDetail.vue?vue&type=template&id=7587d5cd&scoped=true&"
import script from "./RateDetail.vue?vue&type=script&lang=js&"
export * from "./RateDetail.vue?vue&type=script&lang=js&"
import style0 from "./RateDetail.vue?vue&type=style&index=0&id=7587d5cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7587d5cd",
  null
  
)

export default component.exports